import { toast } from "react-toastify";
import { _UBLInvoice } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { useEffect, useState } from "react";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { FileService } from "../../../../core/services/FileService";
import { BasicTable, MASK_BOOLEAN, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { ObjectDinamicViewer } from "../../../contract/etapa-contrato/contrac/ublinvoice/FireElectronicDocument/ObjectDinamicViewer/ObjectDinamicViewer";


interface Props {
    idInvoice: number;
    issueDate: any;
}

export const SeeInvoice = ({ idInvoice, issueDate }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_UBLInvoice);


    useEffect(() => {
        getInvoice();
    }, [idInvoice])

    const getInvoice = () => {
        instance.getUblInvoice(idInvoice, issueDate).then(
            (resp) => {
                setBean(resp)
            }
        ).catch(
            err => {
                toast.error("no se pudo cargar la factura")
            }
        )
    }

    const head = [
        { title: 'ID Factura', property: 'IDUBLInvoice', visible: true, mask: MASK_NUMBER },
        { title: 'Cliente', property: 'AccountCustomerName', visible: true },
        { title: 'Tipo UBL', property: 'UBLDocumentTypeName', visible: true },
        { title: 'Proveedor', property: 'AccountSupplierName', visible: true },
        { title: 'No Factura', property: 'InvoiceID', visible: true },
        { title: 'Líneas Factura', property: 'LineCountNumeric', visible: true },
        { title: 'Valor Total', property: 'TotalInvoiceAmount', visible: true, mask: MASK_MONEY },
        { title: 'Impuesto', property: 'TaxAmount', visible: true, mask: MASK_MONEY },
        { title: 'Descuentos', property: 'DiscountAmount', visible: true, mask: MASK_MONEY },
        { title: 'Aplicar Anticipo', property: 'ApplyPrepaidValue', visible: true, mask: MASK_BOOLEAN },
        { title: 'Valor del Anticipo', property: 'PrepaidPayment', visible: true, mask: MASK_MONEY },
        { title: 'Fecha Factura', property: 'IssueDate', visible: true, mask: MASK_DATE },
        { title: 'Documento Factura', property: 'Doc', visible: true },
        { title: 'Lista de Precios', property: 'PriceListName', visible: true },
        { title: 'Documento IFR', property: 'IFRConsecutive', visible: true },
        { title: 'Entrada de Almacén/Remisión', property: 'Remision', visible: true },
        { title: 'Estado Factura', property: 'DocumentStateName', visible: true },
        { title: 'Tipo Factura', property: 'SourceTypeName', visible: true },
        { title: 'Estado EAF', property: 'EAFDocumentStateName', visible: true },
        { title: 'Documento Soporte', property: 'IsDocumentSupport', visible: true, mask: MASK_BOOLEAN },
        { title: 'Concepto de Ingreso', property: 'AccountantConceptName', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Cuenta Puente Ingreso Bienes', property: 'CreditAccountantIDName', visible: true },
        { title: 'Tipo de Pago', property: 'PaymentTypeName', visible: true },
        { title: 'Días de Vencimiento', property: 'DefeatDays', visible: true },
        { title: 'Utilizar Otra Moneda', property: 'UseOtherCurrency', visible: true },
        { title: 'Moneda de la Transacción', property: 'CurrencyName', visible: true },
        { title: 'Tasa de cambio', property: 'ExchangeRate', visible: true },
        { title: 'Pertenece a Proceso', property: 'ProcessTypeName', visible: true },
    ]

    return (
        <div className="row">
            <div className="col-md-12">
                <ObjectDinamicViewer data={bean} head={head} columns={2} />
            </div>
        </div>
    )
}